/* 
---------------------------------------------------------------
NOTE: This is also included in SCSS stack !!
---------------------------------------------------------------
*/

:host {
	display: inline-grid;
}

.mdln-mico__surface {
	display: grid;
	align-items: center;
	justify-items: center;
}

.mico {
	background-size: 100% 100%;
	mask-size: 100% 100%;
	aspect-ratio: 1 / 1;
	width: calc(1rem * var(--mico-scale, 1));
	rotate: var(--mico-rotate);
	color: var(--mico-color);
	fill: var(--mico-color-fill, none);
	stroke-width: var(--mico-stroke-width, 2);
	stroke-linecap: round;
	stroke-linejoin: round;
}
